module.exports = __webpack_public_path__ + "img/desktop-computer.e96bda5b.png";